import { FormEvent, useState } from "react";
import { sendForm } from "../submit";

const BOOK_GROUPS = [
  ["Standard Online Sessions", [
    "First Intake Assessment (60 min) — R450",
    "Standard Online Session (60 min) — R550",
    "Standard Online Session (45 min) — R420",
    "Students / Unemployed (60 min) — R350",
    "Students / Unemployed (45 min) — R280",
  ]],
  ["Couples", [
    "Couples Intake Assessment (60 min) — R600",
    "Couples Counselling (60 min) — R700",
    "Couples Counselling (90 min) — R950",
  ]],
  ["Groups & Debriefing", [
    "Group Intake Assessment (60 min) — R200 pp",
    "Group Session (60 min) — R250 pp",
    "Individual Debriefing (45–60 min) — R500",
    "Group Debriefing (60–90 min) — R300 pp",
  ]],
] as const;
export function Book() {
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");
  async function submit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    setSending(true);
    setError("");
    try {
      await sendForm("Booking request", form);
      setSent(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Could not send.");
    } finally {
      setSending(false);
    }
  }
  return (
    <section className="wrap-s section">
      <h1 className="center">Book a Session</h1>
      <p className="center soft">Choose a service and time that works for you. I'll confirm your session by email within 24 hours.</p>
      {sent ? (
        <div className="success sage">
          <h2>Thank you</h2>
          <p className="soft">Your request has been received. I'll be in touch shortly.</p>
        </div>
      ) : (
        <form className="form" onSubmit={submit}>
          <label>
            <span>Service</span>
            <select name="service" required defaultValue="">
              <option value="" disabled>Choose a service…</option>
              {BOOK_GROUPS.map(([label, options]) => (
                <optgroup key={label} label={label}>
                  {options.map((option) => <option key={option}>{option}</option>)}
                </optgroup>
              ))}
            </select>
            <span className="hint">Group options require a minimum of 4 people. Evening / weekend sessions add R100 to the relevant rate.</span>
          </label>
          <div className="fields-3">
            <label><span>Full name</span><input name="name" required /></label>
            <label><span>Email</span><input name="email" type="email" required /></label>
            <label><span>Age</span><input name="age" type="number" min={1} max={120} required /></label>
          </div>
          <div className="fields">
            <label><span>Preferred date</span><input name="date" type="date" required /></label>
            <label><span>Preferred time</span><input name="time" type="time" required /></label>
          </div>
          <label>
            <span>Format</span>
            <select name="format" defaultValue="Online"><option>Online</option></select>
          </label>
          <label>
            <span>Anything you'd like me to know (optional)</span>
            <textarea name="message" rows={4} />
          </label>
          <div className="consent-box sage">
            <h2 style={{ fontSize: "1.5rem", margin: 0 }}>Consent</h2>
            <p className="soft" style={{ fontSize: "0.875rem", margin: 0 }}>Please read the full <a className="link" href="/consent" target="_blank" rel="noreferrer">Consent & Boundaries</a> information before booking.</p>
            {["I have read and understood the Consent & Boundaries information.", "I consent to counselling on the terms described.", "I understand the confidentiality policy and its limits."].map((label) => (
              <label className="check" key={label}><input name={label} type="checkbox" value="yes" required /><span>{label}</span></label>
            ))}
          </div>
          <input className="botcheck" type="checkbox" name="botcheck" tabIndex={-1} aria-hidden="true" />
          {error && <p className="form-error">{error}</p>}
          <button className="btn btn-block" type="submit" disabled={sending}>{sending ? "Sending…" : "Request Session"}</button>
        </form>
      )}
    </section>
  );
}
